import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CaregiverListPane } from '@apps/web/components/dashboard/caregiver_list_pane';
import { TrainingModePageTourScope } from '@apps/web/components/page_tour/training_mode_page_tour';
import { CAREGIVERS_PAGE_TOUR_STEPS } from '@apps/web/components/page_tour/training_mode_tour_configs';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export const caregiversSearchSchema = z.object({
    caregiverId: z.string().optional(),
    chatId: z.string().uuid().optional(),
    chatMode: z.enum(['fullscreen']).optional(),
    slackWebClaim: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/caregivers')({
    component: CaregiversPage,
    validateSearch: caregiversSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Caregivers | Phoebe',
            },
        ],
    }),
});

function CaregiversPage() {
    const {
        caregiverId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );
    const organizationId = useOrganizationId();

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return (
        <TrainingModePageTourScope
            pageId="caregivers"
            organizationId={organizationId}
            ready={organizationId !== null}
            steps={CAREGIVERS_PAGE_TOUR_STEPS}
        >
            <CaregiverListPane selectedCaregiverId={caregiverId} />
        </TrainingModePageTourScope>
    );
}
